import React, { PropsWithChildren } from 'react';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { IconButton, Stack, SxProps, Theme, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import { styles } from './styles.ts';

type TSubHeaderProps = {
  title?: string;
  backPath?: string;
  sx?: SxProps<Theme>;
};

export const SubHeader = ({
  title,
  backPath,
  children,
  sx,
}: PropsWithChildren<TSubHeaderProps>) => {
  const navigate = useNavigate();
  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      sx={[
        styles.box,
        { pl: backPath ? '5px' : '60px' },
        ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
      ]}
    >
      <Stack direction={'row'} justifyContent={'start'} alignItems={'center'} gap={2}>
        {backPath && (
          <IconButton onClick={() => navigate(backPath)}>
            <ChevronLeftIcon />
          </IconButton>
        )}
        <Typography variant="h2" typography="text.primary">
          {title}
        </Typography>
      </Stack>
      {children}
    </Stack>
  );
};
